import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  organizations: any[] = []; // Initialize to an empty array

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {

    this.apiService.getAllOrganizations().subscribe(
      data => {
        this.organizations = data;
      },
      error => {
        console.error('Error fetching organizations', error);
      }
    );

  }

}
